import {createStore} from 'vuex'
import store from "/src/store";
import {config} from "/src/config";
import {setLocale} from '@/i18n'
import {limpiarPortapapeles} from '@/utils/campoClipboard'
import {esTokenDeEmulacion, volverAlAdmin} from '@/utils/emulacion'

const storagePrefix = 'LC_';

function getStorage(item) {
    let tmp = localStorage.getItem(storagePrefix + item);
    if (tmp) {
        try {
            tmp = JSON.parse(tmp);
            return tmp;
        }
        catch (e) {
            return false;
        }
    }
}
function setStorage(item, data) {
    localStorage.setItem(storagePrefix + item, JSON.stringify(data));
}

export default createStore({
    state: {
        loading: false,
        // Inicializa según viewport: en móvil arranca cerrado (sin backdrop colgado),
        // en desktop arranca visible (sin que CoreUI lo oculte con clase .hide).
        sidebarVisible: typeof window !== 'undefined' && window.innerWidth >= 992,
        sidebarUnfoldable: false,
        startTaskModalTrigger: 0,
        authInfo: getStorage('authInfo')
    },
    mutations: {
        showLoading(state) {
            state.loading = true;
        },
        hideLoading(state) {
            state.loading = false;
        },
        toggleSidebar(state) {
            state.sidebarVisible = !state.sidebarVisible
        },
        toggleUnfoldable(state) {
            state.sidebarUnfoldable = !state.sidebarUnfoldable
        },
        updateSidebarVisible(state, payload) {
            state.sidebarVisible = payload.value
        },
        authSetInfo(state, payload) {

            // El portapapeles de campos del editor de flujos vive en localStorage, así
            // que sobrevive al cierre del navegador: sin esto, el botón "Pegar" aparece
            // con un campo copiado en otra sesión (o por otra persona en la misma
            // máquina). Se limpia cuando cambia quién está logueado — no en cada
            // revalidación de sesión, que llama a esta misma mutación con el mismo
            // usuario y borraría lo que se acaba de copiar.
            const usuarioPrevio = (state.authInfo || {}).username || '';
            const usuarioNuevo = (payload || {}).username || '';
            if (usuarioPrevio !== usuarioNuevo) {
                limpiarPortapapeles();
            }

            setStorage('authInfo', payload);
            state.authInfo = payload;
            // Si el response trae idioma, sincronizar el locale de i18n inmediatamente
            // (cubre el caso de primer login donde detectInitialLocale no encontró idioma en LC_authInfo)
            if (payload && payload.idioma) {
                setLocale(payload.idioma);
            }
        },
        authSetIdioma(state, idioma) {
            const next = { ...(state.authInfo || {}), idioma };
            setStorage('authInfo', next);
            state.authInfo = next;
            setLocale(idioma);
        },
        setDisableSidebar(state, payload) {
            state.disableSidebar = payload;
        },
        triggerStartTaskModal(state) {
            state.startTaskModalTrigger++;
        },
    },
    getters: {
        loading: state => {
            return state.loading;
        },
        authInfo: state => {
            return state.authInfo;
        },
        authLogged: state => {
            return (typeof state.authInfo.logged !== 'undefined' && state.authInfo.logged === 1);
        },
        checkAccess: (state, access) => {
            console.log(access);
        },
        disableSidebar: (state, access) => {
            return state.disableSidebar;
        },
        sidebarStatus: (state, access) => {
            return state.sidebarVisible;
        },
    },
    actions: {
        disableSidebar: ({commit, getters}, payload) => {
            commit('setDisableSidebar', payload);
        },
        showLoading: ({commit, getters}, payload) => {
            commit('showLoading');
        },
        hideLoading: ({commit, getters}, payload) => {
            commit('hideLoading');
        },
        ValidateLogin: ({commit, getters}, payload) => {

            //store.dispatch('coreShowLoading');
            const token = (typeof getters.authInfo !== 'undefined' && typeof getters.authInfo.token !== 'undefined') ? getters.authInfo.token : '';

            fetch(config.backendUrl + '/auth/validate-login', {
                method: "POST",
                body: JSON.stringify({
                    //t: token,
                }),
                headers: {
                    "Content-Type": "application/json",
                    'Authorization': 'Bearer ' + token
                },
            })
                .then(response => response.json())
                .then(response => {

                    if (typeof response.status !== 'undefined') {

                        // si está logueado
                        if (response.status) {
                            response.data.token = token;
                            commit('authSetInfo', response.data);
                        }
                        else if (esTokenDeEmulacion(token)) {
                            // La emulación terminó o venció: se vuelve a la sesión del super admin
                            volverAlAdmin();
                            return;
                        }
                        else {
                            commit('authSetInfo', {});
                        }

                        // Callback
                        if (typeof payload.callback === 'function') {
                            payload.callback(response.data);
                        }

                        //store.dispatch('coreHideLoading');
                    }
                    else {
                        // deslogueo
                        commit('authSetInfo', {});
                        //store.dispatch('coreHideLoading');
                    }
                })
                .catch(() => {
                    //console.log(e);
                    //store.dispatch('coreHideLoading');
                    // Callback
                    if (typeof payload.callback === 'function') {
                        payload.callback(false);
                    }
                    //window.location.href = "/#/login";
                });
        },
    },
    modules: {},
})
